import { AccountingIntegrationSettings } from '@accounting-integrations/interfaces/accounting-integrations';
import { AdvancedPrefixManagement } from '@accounting-integrations/interfaces/advanced-prefix-management';
import { AccessControlConfigInterface } from './access-control-config-interface';

export class CenterSetting {
  id: number;
  center_id: number;
  default_slot_duration: number;
  default_start_hour: string;
  default_end_hour: string;
  default_language: string;
  logo_url: string;
  header_image_url: string;
  name: string;
  street: string;
  street2: string;
  zip: string;
  city: string;
  country: string;
  vat_number: string;
  phone1: string;
  email1: string;
  website: string;
  center_type: string;
  multisports: boolean;
  team_sports: boolean;
  register_t_and_c_post_id: number;
  enrollment_t_and_c_post_id: number;
  interior_regulations_post_id: number;
  privacy_policy_post_id: number;
  terms_of_sale: number;
  money_transfer_activated: boolean;
  money_transfer_confirmation_page_info: string;
  bancontact_activated: boolean;
  allow_coupon: boolean;
  activate_shopping_cart: boolean;
  stripe_activated: boolean;
  stripe_public_key: string;
  stripe_private_key: string;
  stripe_webhook_key: string;
  payfip_activated: boolean;
  available_languages: string[];
  show_menu_entries: string[];
  show_menu_entries_for_organization: string[];
  show_birthdate: string;
  show_gender: string;
  show_address_fields: string;
  show_phone: string;
  show_phone2: string;
  show_email2: string;
  show_id_card_number: string;
  show_passport_number: string;
  show_registration_number: string;
  show_external_reference: string;
  mandatory_birthdate: string;
  mandatory_gender: string;
  mandatory_address_fields: string;
  mandatory_phone: string;
  mandatory_id_card_number: string;
  created_at: string;
  activity_page_header: string;
  home_page: string;
  contact_profile_home_page: string;
  deleted_at: string;
  updated_at: string;
  background: object;
  show_activity_categories_in_profile: boolean;
  ticket_header: string;
  ticket_footer: string;
  accounting_integration_settings?: AccountingIntegrationSettings;
  advanced_prefix_management?: AdvancedPrefixManagement;
  analytics_usage: boolean;
  activate_sepa_direct_debit: boolean;
  group_subvention_on_invoices: boolean;
  show_activity_management_page?: boolean;
  subvention_mode: string;
  default_invoice_layout: string;
  cancelled_unpaid_booking_remain_due: boolean;
  cancelled_paid_booking_generate_refund: boolean;
  allow_booking_refunds: boolean;
  send_summons_email: boolean;
  summons_email_title: string;
  summons_email_template_id: number;
  email_blind_copy_summons: string[];
  admin_send_summons_email: boolean;
  use_new_cms: boolean;
  free_bookings_activated: boolean;
  use_pos_v2: boolean;
  use_contact_relations_v2: boolean;
  enable_contact_card: boolean;
  use_article_impacts: boolean;
  use_multiplayer_bookings: boolean;
  display_booking_calendar_with_contact_color: boolean;
  nepting_merchant_id: string;
  source_color_to_display_booking_calendar: string;
  send_subscription_recredit_email: boolean;
  admin_send_subscription_recredit_email: boolean;
  subscription_recredit_email_title: string;
  subscription_recredit_email_template_id: number;
  email_blind_copy_subscription_recredit: string;
  pos_discounts_allowed: boolean;
  pos_refunds_allowed: boolean;
  invoice_from_ticket_contact_id: number;
  access_control_config?: AccessControlConfigInterface;
  subscription_payment_request_email_template_id: number;
  subscription_payment_reminder_email_template_id: number;
  enrollment_payment_request_email_template_id: number;
  enrollment_payment_reminder_email_template_id: number;
}
